export default __webpack_public_path__ + "static/media/PayPal.7f2c798b.svg";